<template>
  <!--STEG 1-->
  <CheckoutSelectNumberKeepNumberCode
    v-if="hasNotValidated"
    :cart-item-id="cartItemId"
    :bundle-id="bundleId"
    :show-transfer-owner-ssn="false"
    :parent-msisdn="parentMsisdn"
  >
    <template #visibleBeforeSubmit>
      <p>
        För att verifiera att numret är ditt skickar vi ett SMS till dig med en
        kod.
      </p>
    </template>
  </CheckoutSelectNumberKeepNumberCode>

  <!--STEG 2-->
  <CheckoutSelectNumberKeepNumberValidateCode
    v-if="codeHasBeenSentButNotValidated"
    :cart-item-id="cartItemId"
    :bundle-id="bundleId"
  />

  <!--STEG 3-->

  <AppNotification
    v-if="numberConfig.keepNumberCodeValidated"
    border-color="border-border-success"
  >
    <template #header>
      <nuxt-icon
        filled
        name="check-circle-green"
        class="text-[2.4rem]"
        aria-hidden="true"
      />
      <p class="heading-xxs" aria-hidden="true">
        {{ numberConfig.keepNumberInputValue }}
        är redo för flytt!
      </p>
    </template>
    <div class="flex flex-col gap-8" aria-live="polite" role="status">
      <span class="sr-only">Numret är redo för flytt!</span>
      <p>
        Ditt nuvarande nummer är godkänt för flytt till ditt nya Halebop
        abonnemang.
      </p>
    </div>
    <button
      class="pt-8 body-link-md text-text-link underline halebop-focus hover:text-text-link-hover active:bg-surface-action-hover"
      @click="reset"
    >
      Ändra
    </button>
  </AppNotification>

  <!--STEG 3-->
</template>

<script lang="ts" setup>
interface Props {
  cartItemId: number;
  bundleId: number;
  parentMsisdn?: string;
}
const props = withDefaults(defineProps<Props>(), { parentMsisdn: undefined });

const { codeHasBeenSentButNotValidated, hasNotValidated, numberConfig, reset } =
  useSelectNumberConfig({
    cartItemBundleId: props.bundleId,
    cartItemId: props.cartItemId,
  });
</script>

<style scoped lang="scss"></style>
